import { render, staticRenderFns } from "./AirwallexCard.vue?vue&type=template&id=710ba1aa&scoped=true"
import script from "./AirwallexCard.vue?vue&type=script&lang=js"
export * from "./AirwallexCard.vue?vue&type=script&lang=js"
import style0 from "./AirwallexCard.vue?vue&type=style&index=0&id=710ba1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ba1aa",
  null
  
)

export default component.exports